import { InvalidStateError } from '#common/types';
import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
export class FilePermissionsWasm extends Synchronized {
    mod;
    principalsRsaKeysFetch = () => {
        throw new InvalidStateError('fetchPrincipalsRSAKeyPairsHandler is not set!');
    };
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    setUp(principalsRsaKeysFetch) {
        this.principalsRsaKeysFetch = principalsRsaKeysFetch;
        this.mod['fetchPrincipalsRSAKeyPairsHandler'] = async (principalIds) => {
            this.checkWasmReentrance();
            return this.principalsRsaKeysFetch(principalIds);
        };
    }
    async grantAccess(principalId, entryId, permissions) {
        return await this.mutex.runExclusive(async () => {
            parseWasmResult(await this.mod.GrantAccess(principalId, entryId, permissions));
        });
    }
    async revokeAccess(principalId, entryId) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.RevokeAccess(principalId, entryId));
        });
    }
    async listPermissionsPartialFrom(principalId, linkId, limit, cursor) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ListPermissionsPartialFrom(principalId, linkId, limit, cursor));
        });
    }
    async listPermissionsPaginated(limit, cursor) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ListPermissionsPaginated(limit, cursor));
        });
    }
    async listPermissionsPaginatedFilteredByFileId(linkIds, limit, cursor) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ListPermissionsPaginatedFilteredByFileId(linkIds, limit, cursor));
        });
    }
    async listPermissionsPaginatedFilteredByPrincipalId(principalIds, limit, cursor) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ListPermissionsPaginatedFilteredByPrincipalId(principalIds, limit, cursor));
        });
    }
    async refreshAccess(permissionsCrypto, isAdmin, force) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.RefreshAccess(permissionsCrypto, isAdmin, force));
        });
    }
}
